const popupCloseComponent = (editor, componentOpts) => {
  const dc = editor.DomComponents;

  const popupCloseOptions = componentOpts["popup-close"];
  const {
    name,
    type,
    mainAttribute,
    closeAttribute,
  } = popupCloseOptions;

  const traitOpts = [
    {
      type: "text",
      name: "id",
      label: "ID",
      placeholder: "Enter id...",
    },
    {
      type: "select",
      name: closeAttribute,
      label: "Popup Close",
      options: [
        { name: "Only this popup", id: "this" },
        { name: "Close all popups", id: "all" },
      ]
    }
  ];

  dc.addType(type, {
    isComponent: (el) =>
      el.tagName === "DIV" &&
      el.getAttribute(mainAttribute) === type,

    model: {
      defaults: {
        tagName: "div",
        removable: true, // Can't remove it
        draggable: true, // Can't move it
        droppable: true, // Can't drop any components inside this
        copyable: true, // Disable copy/paste
        resizable: true,
        attributes: {
          [mainAttribute]: type,
          [closeAttribute]: "this",
          "data-gjs-type": type,
          "data-gjs-name": name,
        },
        traits: traitOpts
      },
    },
  });
};

export default popupCloseComponent;
